/**
 * adminApi.js
 * システム管理者（superadmin）用 API クライアント
 */
import { getSession, signOut } from './auth';

const API_BASE = process.env.REACT_APP_API_ENDPOINT;

async function authFetch(path, options = {}) {
  let session;
  try {
    session = await getSession();
  } catch (err) {
    signOut();
    window.location.href = '/login';
    throw new Error('Session expired');
  }
  const url = `${API_BASE}${path}`;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: session.idToken,
    ...options.headers,
  };
  const response = await fetch(url, { ...options, headers });
  if (response.status === 401) {
    signOut();
    window.location.href = '/login';
    throw new Error('Unauthorized');
  }
  if (response.status === 403) {
    throw new Error('この操作にはシステム管理者権限が必要です');
  }
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || `API Error: ${response.status}`);
  return data;
}

// ============================================================
// 組織管理 API
// ============================================================
export const organizationApi = {
  list: async (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return authFetch(`/admin/organizations${q ? `?${q}` : ''}`);
  },
  create: (body) => authFetch('/admin/organizations', {
    method: 'POST',
    body: JSON.stringify(body),
  }),
  update: (orgId, body) => authFetch(`/admin/organizations/${encodeURIComponent(orgId)}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  }),
  delete: (orgId) => authFetch(`/admin/organizations/${encodeURIComponent(orgId)}`, {
    method: 'DELETE',
  }),
};

// ============================================================
// ユーザー管理 API
// ============================================================
export const adminUserApi = {
  list: async (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return authFetch(`/admin/users${q ? `?${q}` : ''}`);
  },
  update: (userId, body) => authFetch(`/admin/users/${encodeURIComponent(userId)}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  }),
  delete: (userId, orgId) => authFetch(
    `/admin/users/${encodeURIComponent(userId)}?orgId=${encodeURIComponent(orgId)}`,
    { method: 'DELETE' }
  ),
};

// ============================================================
// ドローン管理 API
// ============================================================
export const adminDroneApi = {
  /** 機体一覧（IoT Core の Thing を読み取り専用で返す）。params: orgId, status, limit, lastKey */
  list: async (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return authFetch(`/admin/drones${q ? `?${q}` : ''}`);
  },
};

// ============================================================
// 統計 API
// ============================================================
export const statsApi = {
  get: () => authFetch('/admin/stats'),
};
